export default "__VITE_ASSET__2SsahA$f__"